import HoverCard from "./HoverCard";
import { typography, colors } from "../../styles/index";

export default function StatCard({ label, value, onClick, icon: Icon, color }) {
  return (
    <HoverCard onClick={onClick}>
      <div style={{ 
        display: "flex", 
        alignItems: "center", 
        justifyContent: "space-between",
        marginBottom: 8,
      }}>
        <div style={{ 
          fontSize: "1.75rem", 
          fontWeight: 700,
          color: color || colors.text,
        }}>
          {value}
        </div>
        {Icon && (
          <Icon 
            size={24} 
            style={{ 
              color: color || colors.textMuted,
              opacity: 0.6,
            }} 
          />
        )}
      </div>
      <div
        style={{
          ...typography.small,
          color: colors.textMuted,
          marginTop: 6,
        }}
      >
        {label}
      </div>
    </HoverCard>
  );
}
